import "./Preloader.scss";
import React, { useEffect, useState } from 'react';
import { useUtils } from "../../helpers/utils.js";
import { useScheduler } from "../../helpers/scheduler.js";

const Status = {
  ANIMATING: "animating",
  SHOWN: "shown",
  HIDING: "hiding",
  HIDDEN: "hidden"
};

const SCHEDULER_TAG = 'fs-loader';

function Preloader({ children }) {
  const utils = useUtils();
  const scheduler = useScheduler();

  const [visible, setVisible] = useState(true);
  const [spinnerClass, setSpinnerClass] = useState('spinner-hidden');
  const [contentInfoClass, setContentInfoClass] = useState('loader-content-info-hidden');
  const [status, setStatus] = useState(Status.ANIMATING);
  const [didLoadAssets, setDidLoadAssets] = useState({ svg: false });

  const title = ' Welcome to <b>Xtram Ltd</b>';
  const subtitle = 'POWERED BY RabbitsIT';

  useEffect(() => {
    if (didLoadAssets.svg ) {
      _tweenIn();
    }
  }, [didLoadAssets]);

  const _tweenIn = () => {
    scheduler.clearAllWithTag(SCHEDULER_TAG);

    scheduler.schedule(() => {
      setSpinnerClass('');
    }, 100, SCHEDULER_TAG);

    scheduler.schedule(() => {
      setContentInfoClass('');
    }, 500, SCHEDULER_TAG);

    scheduler.schedule(() => {
      setStatus(Status.SHOWN);
      utils.addClassToBody('body-with-image');
    }, 900, SCHEDULER_TAG);

    scheduler.schedule(() => {
      _hide();
    }, 2500, SCHEDULER_TAG);
  };

  const _hide = () => {
    scheduler.clearAllWithTag(SCHEDULER_TAG);
    setStatus(Status.HIDING);

    scheduler.schedule(() => {
      setStatus(Status.HIDDEN);
      setVisible(false);
    }, 400, SCHEDULER_TAG);
  };

  return (
    <>
      {visible && (
        <div className={`loader loader-${status === Status.ANIMATING || status === Status.SHOWN ? 'visible' : 'hidden'}`}>
          <div className={`loader-content text-white`}>
            <img
              src={utils.resolvePath(`/images/logo-white.svg`)}
              onLoad={() => setDidLoadAssets(prev => ({ ...prev, svg: true }))}
              className={`spinner ${spinnerClass}`}
              alt="loader"
            />
            <div className={`loader-content-info ${contentInfoClass}`}>
              <div className={`title-wrapper`}>
                <h5 dangerouslySetInnerHTML={{ __html: title }} />
              </div>
              <p className="opacity-50 text-4 text-center" dangerouslySetInnerHTML={{ __html: subtitle }} />
            </div>
          </div>
        </div>
      )}
      {status !== Status.ANIMATING && <>{children}</>}
    </>
  );
}

export default Preloader;
